"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CGJPlayer = void 0;
const CGJEntity_1 = require("./CGJEntity");
class CGJPlayer extends CGJEntity_1.CGJEntity {
    constructor(scene, pos, size) {
        super(scene, Math.random() < 0.5 ? "Girl" : "Boy", pos, size, new Phaser.Geom.Rectangle(2, 12, 12, 4));
    }
}
exports.CGJPlayer = CGJPlayer;
